import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WindowRefService } from './services/windowRef.service';
import { ApiService } from './services/api.service';
import { FlagService } from './services/flag.service';
import { HubstaffApiService } from './services/hubstaff-api.service';

@NgModule({
  declarations: [],
  providers: [WindowRefService, ApiService, FlagService, HubstaffApiService],
  imports: [CommonModule],
})
export class CoreModule {}
